'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".PickupLocationHoursDisclosure-module_root__ZDCyC{margin-top:.5rem}.PickupLocationHoursDisclosure-module_hoursList__-XHqz{list-style:none;margin:.5rem 0 0;padding:0}.PickupLocationHoursDisclosure-module_hoursListItem__FdqJ4{display:flex;flex-wrap:wrap;justify-content:space-between}.PickupLocationHoursDisclosure-module_hoursListItemDetail__XKqZg{margin:0}";
var styles = {"root":"PickupLocationHoursDisclosure-module_root__ZDCyC","hoursList":"PickupLocationHoursDisclosure-module_hoursList__-XHqz","hoursListItem":"PickupLocationHoursDisclosure-module_hoursListItem__FdqJ4","hoursListItemDetail":"PickupLocationHoursDisclosure-module_hoursListItemDetail__XKqZg"};
styleInject["default"](css_248z, '00b9add7-1f58-48fe-be62-800dfcdc043d');

exports["default"] = styles;
